/** Relay (Blob) data-plane helpers shared by Cloud Functions and client. */

/** Hard file-size cap for relay uploads (just under 1 GiB). */
export const RELAY_MAX_FILE_BYTES = 1024 * 1024 * 1024 - 1

export function normalizeCodeRaw(code: string): string {
  return String(code || '').trim().toUpperCase()
}

/** 4–8 alnum room short-code. */
function assertValidCode(code: string): string {
  const n = normalizeCodeRaw(code)
  if (!/^[A-Z0-9]{4,8}$/.test(n)) {
    throw new Error(`Invalid relay room code: ${JSON.stringify(code)}`)
  }
  return n
}

export function isValidRelayId(id: string): boolean {
  return /^[A-Za-z0-9_-]{1,64}$/.test(String(id || ''))
}

/** Room manifest blob key. */
export function relayManifestKey(code: string): string {
  return `relay/${assertValidCode(code)}/manifest`
}

/** File content blob key. */
export function relayFileKey(code: string, id: string): string {
  const safe = isValidRelayId(id) ? id : ''
  if (!safe) throw new Error(`Invalid relay file id: ${JSON.stringify(id)}`)
  return `relay/${assertValidCode(code)}/f/${safe}`
}

/** Room-wide prefix used by cleanup. */
export function relayRoomPrefix(code: string): string {
  return `relay/${assertValidCode(code)}/`
}

/** Uploader role; the peer downloads what the other side uploaded. */
export type RelayFrom = 'host' | 'guest'

export interface RelayFileEntry {
  id: string
  name: string
  size: number
  type: string
  from: RelayFrom
  at: string
}

export interface RelayManifest {
  rev: number
  files: RelayFileEntry[]
}
